import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CaseNumberTooltip from '../tooltips/caseNumberTooltip/CaseNumberTooltip';
import { mapValidationFieldsToClassName } from '../../forms/inputValidations';


class CaseNumberSelector extends Component {
  componentWillReceiveProps(nextProps) {
    this.refs.case_no.value = nextProps.value || '';
  }

  onChange = () => {
    const { value } = this.refs.case_no;
    this.props.onChange({ case_no: value });
  }

  render() {
    return (
      <div className="form-item">
        <label htmlFor="case-number">Case Number: </label>
        <input type="text"
               maxLength="128"
               id="case-number"
               size="60"
               ref="case_no"
               onChange={this.onChange}
               className={this.props.className} />
        <CaseNumberTooltip />
      </div>
    );
  }
}

CaseNumberSelector.defaultProps = {
  className: '',
  value: '',
};

CaseNumberSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.any,
  value: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    className: mapValidationFieldsToClassName(state, 'case_no', 'input-search').className,
    value: state.getIn(['pacerSearchResults', 'filters', 'case_no']),
  };
}

export default connect(mapStateToProps)(CaseNumberSelector);



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/caseSelector/CaseNumberSelector.jsx
 **/